import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { TID } from '@/lib/testIds';

export const StepperHeader = ({ steps, current }) => (
  <div data-testid={TID.book.stepper} className="flex items-center justify-between gap-1 mb-6">
    {steps.map((s, i) => {
      const done = i < current;
      const active = i === current;
      return (
        <React.Fragment key={s.key}>
          <div className="flex flex-col items-center min-w-[60px]">
            <motion.div
              initial={false}
              animate={{ scale: active ? 1.05 : 1 }}
              className={`h-9 w-9 rounded-full flex items-center justify-center border-2 ${done ? 'bg-[hsl(var(--sb-green))] border-[hsl(var(--sb-green))] text-black' : active ? 'border-[hsl(var(--sb-gold))] text-[hsl(var(--sb-gold))]' : 'border-[hsl(var(--sb-border))] text-white/40'}`}
            >
              {done ? <Check size={16} /> : <s.icon size={16} />}
            </motion.div>
            <span className={`mt-1.5 text-[10px] sm:text-xs uppercase tracking-wide ${active ? 'text-[hsl(var(--sb-gold))]' : done ? 'text-[hsl(var(--sb-green))]' : 'text-white/40'}`}>{s.label}</span>
          </div>
          {i < steps.length - 1 && (
            <div className={`h-[2px] flex-1 rounded ${i < current ? 'bg-[hsl(var(--sb-green))]' : 'bg-[hsl(var(--sb-border))]'}`} />
          )}
        </React.Fragment>
      );
    })}
  </div>
);
